import { lazy, Suspense } from "react";

import Loader from "../customs/Customspinner/spinner";

const Main = lazy(() => import("../components/transcript/paymentDetails/paymentDetails"));

const PaymentDetails = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default PaymentDetails;
